const DataSyncObjectStatusEnum = {
  success: 'SUCCESS',
  error: 'ERROR',
  notReceived: 'NOT_RECEIVED'
};

export { DataSyncObjectStatusEnum };
export default DataSyncObjectStatusEnum;
